exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.placeholder-bg[data-v-9698f956] {\n  background-color: #D9D9D9;\n}\n.placeholder-icon[data-v-9698f956] {\n  width: 32px;\n  height: 32px;\n}\n.placeholder-title[data-v-9698f956] {\n  width: 80%;\n  height: 12px;\n}\n.placeholder-number[data-v-9698f956] {\n  width: 40%;\n  height: 24px;\n}\n.placeholder-last-month[data-v-9698f956] {\n  width: 60%;\n  height: 12px;\n}\n", ""]);

// exports
